import type { UserOut } from 'src/api/intranet'

import { getInitials } from './getInitials'

export const userDisplayName = (
  user: UserOut | null | undefined,
  fallback = 'User'
): string =>
  user?.display_name?.trim() ||
  [user?.given_name, user?.family_name].filter(Boolean).join(' ').trim() ||
  fallback

export const userInitials = (user: UserOut | null | undefined): string =>
  getInitials(user?.given_name ?? undefined, user?.family_name ?? undefined)

// Departments are now a SCIM-sourced array ({value, display}); render the
// display labels (falling back to value) as a single comma-joined string.
export const userDepartments = (
  user: UserOut | null | undefined,
  fallback = ''
): string =>
  (user?.departments ?? [])
    .map((d) => d.display ?? d.value)
    .filter(Boolean)
    .join(', ') || fallback
